<template>
  <router-view />
</template>

<script>
export default {
  name: 'WrhDashboard'
};
</script>
